const CARDS = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Celebrity%20couple%20romantic%20scene%20with%20paparazzi%20vibe%2C%20warm%20evening%20lighting%2C%20editorial%20photography%2C%20coral%20tones%2C%20mysterious%20atmosphere&width=600&height=400&seq=card-01&orientation=landscape',
    title: '深度追踪：顶流CP从荧幕到现实的完整时间线',
    excerpt: '从第一次被拍到同框，到社交平台暗戳戳互动，再到深夜同回住所……我们为你整理了一份超详细的时间线。',
    tag: '明星八卦',
    time: '3小时前',
    author: '吃瓜编辑部',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20shopping%20bag%20with%20dramatic%20lighting%2C%20mystery%20and%20scandal%20atmosphere%2C%20warm%20amber%20tones%2C%20editorial%20style&width=600&height=400&seq=card-02&orientation=landscape',
    title: '某女星疑似收到天价礼物，背后金主身份引猜测',
    excerpt: '一张朋友圈截图引爆全网猜测，价值七位数的礼物背后，到底是谁在出手？多位圈内人士给出线索。',
    tag: '深度爆料',
    time: '5小时前',
    author: '匿名爆料人',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20spotlight%2C%20reality%20show%20behind%20the%20scenes%2C%20warm%20lighting%2C%20professional%20production%20environment&width=600&height=400&seq=card-03&orientation=landscape',
    title: '综艺录制现场突发状况，导演与嘉宾当面对峙',
    excerpt: '据现场观众透露，某热门综艺录制过程中发生激烈争执，起因疑似与剧本安排有关。目前已有多方回应。',
    tag: '综艺内幕',
    time: '6小时前',
    author: '现场目击者',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20phone%20screen%20showing%20viral%20post%2C%20dramatic%20warm%20lighting%2C%20online%20drama%20concept%2C%20modern%20digital%20aesthetic&width=600&height=400&seq=card-04&orientation=landscape',
    title: '网红圈集体互撕，聊天记录曝光让粉丝集体脱粉',
    excerpt: '一场由截图引发的连环爆料，多位百万粉丝网红卷入其中，真实关系远比表面复杂。完整聊天记录首次公开。',
    tag: '网红翻车',
    time: '8小时前',
    author: '吃瓜前线',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20setup%20with%20dramatic%20moment%2C%20streamer%20shocked%20expression%20concept%2C%20warm%20dramatic%20lighting%2C%20entertainment%20news%20style&width=600&height=400&seq=card-05&orientation=landscape',
    title: '知名游戏主播直播中意外自曝，观众人数瞬间破百万',
    excerpt: '一场普通的游戏直播，因为主播的一句"无心之言"直接引爆全网。回放已被删除，但我们拿到了完整录屏。',
    tag: '直播塌房',
    time: '10小时前',
    author: '录屏组',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Sports%20stadium%20dramatic%20moment%20with%20warm%20sunset%20lighting%2C%20athlete%20emotional%20scene%2C%20editorial%20photography%20style&width=600&height=400&seq=card-06&orientation=landscape',
    title: '体育明星深夜发文暗示退役，评论区粉丝哭声一片',
    excerpt: '一篇长文让整个体育圈震动。虽然经纪人随后否认，但多方消息源确认，这可能不是空穴来风。',
    tag: '体育八卦',
    time: '12小时前',
    author: '体坛观察',
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=Korean%20entertainment%20company%20building%20dramatic%20night%20scene%2C%20mysterious%20atmosphere%2C%20warm%20street%20lighting%2C%20editorial%20photography&width=600&height=400&seq=card-07&orientation=landscape',
    title: '韩娱圈大地震！某经纪公司被曝全员解约',
    excerpt: '韩国娱乐圈今日爆出重磅消息，一家中型经纪公司被曝已与旗下全部艺人解约，原因成谜。海外站持续跟进。',
    tag: '海外爆料',
    time: '14小时前',
    author: '海外通讯员',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            深度报道
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            深度爆料
          </h2>
          <p className="text-sm text-foreground-500 mt-3">每一条爆料都有据可查</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARDS.slice(0, 6).map((card) => (
            <div
              key={card.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-all duration-200 flex flex-col"
            >
              <div className="relative overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full aspect-[3/2] object-cover group-hover:scale-105 transition-transform duration-500"
                  width="600"
                  height="400"
                />
                <span className="absolute top-3 left-3 text-[11px] px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-700 font-medium whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 flex flex-col gap-2 flex-1">
                <h3 className="text-sm font-bold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                  {card.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400 pt-1 border-t border-background-200/50">
                  <span>{card.author}</span>
                  <span>{card.time}</span>
                </div>
              </div>
            </div>
          ))}
          <div className="sm:col-span-2 lg:col-span-3">
            <div className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-all duration-200 flex flex-col sm:flex-row">
              <div className="sm:w-2/5 relative overflow-hidden">
                <img
                  src={CARDS[6].image}
                  alt={CARDS[6].title}
                  className="w-full h-48 sm:h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="600"
                  height="400"
                />
                <span className="absolute top-3 left-3 text-[11px] px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-700 font-medium whitespace-nowrap">
                  {CARDS[6].tag}
                </span>
              </div>
              <div className="p-5 flex flex-col justify-center gap-3 flex-1">
                <h3 className="text-base font-bold text-foreground-900 leading-snug hover:text-primary-500 transition-colors cursor-pointer">
                  {CARDS[6].title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {CARDS[6].excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span>{CARDS[6].author}</span>
                  <span>{CARDS[6].time}</span>
                  <span className="whitespace-nowrap text-primary-500 font-medium cursor-pointer">阅读全文 <i className="ri-arrow-right-line text-xs"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}